import { UCWebsiteBannerSlide } from '@shared/components/@organisms/UCWebsiteBanner/types';

import { ISBWebsiteBannerStory } from './types';

export const replaceCategoryPath = (categoryPrefix: string, link: string) => {
  if (!link) return;
  return link.replace('categories/', `${categoryPrefix}/`);
};

export const transformWebsiteBannerSlide =
  (categoryPrefix: string) =>
  (sbWebsiteBannerStory: ISBWebsiteBannerStory): UCWebsiteBannerSlide => ({
    id: sbWebsiteBannerStory.content._uid,
    title: sbWebsiteBannerStory.content.banner_title,
    countdownTime: sbWebsiteBannerStory.content.countdown_time,
    link: replaceCategoryPath(
      categoryPrefix,
      sbWebsiteBannerStory.content.link_to_announcement?.url ||
        sbWebsiteBannerStory.content.link_to_announcement?.cached_url,
    ),
  });
